const cloudFrontLoader = ({ src, width }) => {
    return `${src}?w=${width}`;
};

export default cloudFrontLoader;
